import type {GeoLocation} from "~/types";

export const useNavSearch = () => {
  const filterCity = useCookie<string | null>('city-filter', {
    default: () => '',
  })

  const filterType = useCookie<string>('filter-type', {
    default: () => 'Qualquer lugar'
  })

  const geolocation = useCookie<GeoLocation>('geo-location', {
    default: () => ({
      latitude: null,
      longitude: null
    })
  })

  const loadGeoLocation = async () => {
    if ('geolocation' in navigator) {
      const {state} = await navigator.permissions?.query({name: 'geolocation'})
      if (state === 'denied') {
        Alert.error(`
        <div style="text-align: left">
          <p>Para que possamos identificar sua localização e melhorar sua experiência, é necessário permitir o acesso à geolocalização no seu navegador.</p>
          <p>Siga os passos abaixo:</p>
          <ul>
            <li><b>Procure por um ícone de cadeado 🔒 ou localização 📍 próximo à barra de endereços.</b></li>
            <li><b>Clique nele para abrir as configurações do site.</b></li>
            <li><b>Encontre a opção "Localização" ou "Geolocalização".</b></li>
            <li><b>Altere para "Permitir" ou "Sempre permitir neste site".</b></li>
            <li><b>Atualize a página (F5) para que as alterações tenham efeito.</b></li>
          </ul>
        </div>
        `)
      }
      navigator.geolocation.getCurrentPosition((position) => {
          geolocation.value.latitude = position.coords.latitude
          geolocation.value.longitude = position.coords.longitude
          filterType.value = 'Usar minha localização atual'
          filterCity.value = null
        },
        (error) => {
          filterType.value = 'Qualquer Lugar'
          console.error('Erro ao obter localização:', error.message);
        }
      );
    }
  }

  return {
    geolocation,
    loadGeoLocation,
    filterCity,
    filterType
  }
}
